<template>
  <div class="grid" data-cy="advanced-search-container">
    <div class="col">
      <span class="p-input-icon-left">
        <icon class="text-gray-600" :icon="['far', 'search']" />
        <InputText
          v-model="sizingsSearch.globalSearchText"
          type="search"
          placeholder="Search by sizing name..."
          class="w-full"
          data-cy="global-search-input"
        />
      </span>
    </div>
    <LabelledToggle
      v-model="isAdvanced"
      class="col-fixed text-right"
      text="Advanced Filters"
      data-cy="advanced-filters-toggle"
    />
    <transition name="horizontal-slide">
      <div v-if="isAdvanced" class="col-12" data-cy="advanced-filters">
        <div class="grid">
          <div v-if="!hideWell" class="col-12 md:col-3">
            <span class="p-input-icon-left">
              <icon class="text-gray-600" :icon="['fas', 'oil-well']" />
              <InputText
                id="selected-well"
                v-model="sizingsSearch.wellSearchText"
                type="search"
                placeholder="Well"
                class="w-full"
                data-cy="well-search-input"
              />
            </span>
          </div>
          <div class="col-12 md:col-3">
            <span class="p-input-icon-left">
              <icon class="text-gray-600" :icon="['fas', 'user']" />
              <InputText
                id="selected-customer"
                v-model="sizingsSearch.customerSearchText"
                type="search"
                placeholder="Customer"
                class="w-full"
                data-cy="customer-search-input"
              />
            </span>
          </div>
          <div v-if="!hideOwner" class="col-12 md:col-3">
            <span class="p-input-icon-left">
              <icon class="text-gray-600" :icon="['far', 'house-user']" />
              <InputText
                id="selected-owner"
                v-model="sizingsSearch.ownerSearchText"
                type="search"
                placeholder="Owner"
                class="w-full"
                data-cy="owner-search-input"
              />
            </span>
          </div>
          <div class="col">
            <span class="p-input-icon-left">
              <icon class="text-gray-600" :icon="['far', 'calendar']" />
              <Calendar
                id="date-range"
                v-model="sizingsSearch.dateRange"
                v-tooltip.top="'Sizings modified between start and end dates'"
                class="w-full"
                selection-mode="range"
                :manual-input="false"
                show-button-bar
                placeholder="updated between mm/dd/yyyy and mm/dd/yyyy"
                data-cy="date-range-input"
              />
            </span>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import type { SizingsSearch } from "@/components/types";

import { ref, watch } from "vue";

import Calendar from "primevue/calendar";
import LabelledToggle from "@/components/LabelledToggle.vue";

const props = defineProps<{
  sizingsSearch: SizingsSearch;
  hideOwner?: boolean;
  hideWell?: boolean;
}>();

const emit = defineEmits<{
  (e: "update:sizings-search", value: SizingsSearch): void;
}>();

const sizingsSearch = ref<SizingsSearch>(props.sizingsSearch);

watch(
  () => props.sizingsSearch,
  newV => {
    sizingsSearch.value = newV;
  }
);

watch(
  sizingsSearch.value,
  newV => {
    emit("update:sizings-search", newV);
  },
  { deep: true }
);

const isAdvanced = ref(
  !!sizingsSearch.value.dateRange?.length ||
    !!sizingsSearch.value.wellSearchText ||
    !!sizingsSearch.value.customerSearchText ||
    !!sizingsSearch.value.ownerSearchText
);
</script>
